(function () {
  function addSwipe(el, onSwipe) {
    var x0 = null, y0 = null, locked = false;
    el.addEventListener('pointerdown', function (e) {
      if (e.button) return;
      x0 = e.clientX; y0 = e.clientY; locked = false;
      try { el.setPointerCapture(e.pointerId); } catch (err) {}
    });
    el.addEventListener('pointermove', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0, dy = e.clientY - y0;
      if (!locked && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) locked = true;
    });
    function end(e) {
      if (x0 === null) return;
      var dx = e.clientX - x0;
      x0 = null;
      if (locked && Math.abs(dx) > 40) onSwipe(dx < 0 ? 1 : -1);
      locked = false;
    }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', function () { x0 = null; locked = false; });
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var originals = Array.prototype.slice.call(track.querySelectorAll('[data-carousel-slide]'));
    var n = originals.length;
    if (n === 0) return;

    if (n < 2) {
      originals[0].classList.add('is-active');
      return;
    }

    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));

    function measure() {
      var ref = track.querySelector('[data-carousel-slide]') || originals[0];
      var slideW = ref.offsetWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var viewport = root.clientWidth;
      return { step: slideW + gap, slideW: slideW, gap: gap, viewport: viewport };
    }

    var m = measure();
    var perView = Math.max(1, Math.ceil(m.viewport / m.step));
    var copies = Math.max(5, perView * 2 + 3);

    track.innerHTML = '';
    var all = [];
    for (var c = 0; c < copies; c++) {
      for (var i = 0; i < n; i++) {
        var clone = originals[i].cloneNode(true);
        clone.removeAttribute('id');
        clone.setAttribute('data-real', String(i));
        track.appendChild(clone);
        all.push(clone);
      }
    }

    var base = Math.floor(copies / 2) * n;
    var pointer = base;
    var animating = false;

    function render(animate) {
      m = measure();
      var offset = (m.viewport - m.slideW) / 2 - pointer * m.step;
      track.style.transition = animate ? '' : 'none';
      track.style.transform = 'translateX(' + offset + 'px)';
      if (!animate) {
        void track.offsetHeight;
        track.style.transition = '';
      }
      var real = ((pointer % n) + n) % n;
      all.forEach(function (s, idx) {
        s.classList.toggle('is-active', idx === pointer);
      });
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === real);
      });
    }

    function normalize() {
      if (pointer < n) {
        pointer += n;
        render(false);
      } else if (pointer >= all.length - n) {
        pointer -= n;
        render(false);
      }
    }

    function move(dir) {
      if (animating) return;
      animating = true;
      pointer += dir;
      render(true);
    }

    track.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'transform') return;
      animating = false;
      normalize();
    });

    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        if (animating) return;
        var real = ((pointer % n) + n) % n;
        var diff = i - real;
        if (diff === 0) return;
        animating = true;
        pointer += diff;
        render(true);
      });
    });

    addSwipe(track, function (dir) { move(dir); });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { render(false); }, 150);
    });

    render(false);
  }

  function initAll() {
    document.querySelectorAll('[data-hero-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-hero-carousel]').forEach(initCarousel);
  });
})();
